import React, { useState, useEffect, useCallback } from "react";
import { Spin, Card } from "antd";
import { useParams } from "react-router-dom";
import { TenantService } from "../../../Services";
import ViewSection from "./Sections/ViewSection";
import AddUpdateSectionsButton from "./Sections/AddUpdateSectionsButton";

export const Filters = () => {
	const { tenantName } = useParams();

	const [loading, setLoading] = useState(false);
	const [tenantSection, setTenantSection] = useState([]);
	const fetchTenantSections = useCallback(async () => {
		setLoading(true);
		const { data } = await TenantService.getTenantSections({ tenantName });
		if (data.filters) {
			setLoading(false);
			setTenantSection(data.filters);
		}
	}, [tenantName]);
	useEffect(() => {
		fetchTenantSections();
	}, [tenantName, fetchTenantSections]);

	return (
		<Card
			title="Filters"
			extra={[
				<AddUpdateSectionsButton
					mode={"add"}
					refetchSections={() => {
						setLoading(true);
						fetchTenantSections();
					}}
				/>
			]}
		>
			<Spin spinning={loading}>
				{tenantSection.map(section => (
					<ViewSection
						section={section}
						key={section.key}
						refetchSections={() => {
							setLoading(true);
							fetchTenantSections();
						}}
					/>
				))}
			</Spin>
		</Card>
	);
};

export default Filters;
